export default {
  hide: 'Сховати меню',
  keepOpen: 'Тримати меню відкритим'
};
